// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"09b27b2c","171":"b85e5f11","307":"a801a40e","374":"e0c80d4d","466":"b2395c47","488":"12a7faff","507":"075f3ac5","511":"33c7a0cc","599":"43af154b","696":"b391237b","949":"17c1bf5e"}[chunkId] + ".chunk.js";
};